/**
 * File: src/api/backend-processes/index.js
 * Layer: API Client
 * Description: Wraps backend-process recovery endpoints for shared
 * long-running workflow state.
 * Created: 2026-08-13
 */
import axios from 'utils/axios';

const BACKEND_PROCESSES_BASE_URL = '/api/backend-processes';

/**
 * Fetch backend processes for the authenticated principal.
 * @param {Object} [params={}]
 * @returns {Promise<Object>}
 */
export const getMyBackendProcesses = async (params = {}) => {
    try {
        const result = await axios.get(BACKEND_PROCESSES_BASE_URL, { params });
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to load backend processes');
    }
};

/**
 * Fetch one backend process for the authenticated principal.
 * @param {string} id
 * @returns {Promise<Object>}
 */
export const getMyBackendProcess = async (id) => {
    try {
        const result = await axios.get(`${BACKEND_PROCESSES_BASE_URL}/${id}`);
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to load backend process');
    }
};
